/* @ngInject */
function ProfileBusinessDataController ($scope, $rootScope, $state, $q, $translate, BusinessDataService, ModalService) {
  const getBusinessDataCreateEditDialogController = () => $q.when(import('../../../arts/dialogs/business-data/create-edit/business-data-create-edit-dialog.controller'))

  $rootScope.selectedMenuId = 2
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId

  const api = {
    activate,
    getBusinessDataCreateEditDialogController
  }
  this.getApi = () => api

  activate()

  function activate () {
    BusinessDataService.getBusinessDataService().then(data => {
      $scope.businessData = data
    })
  }

  const deregisterRefreshBusinessData = $rootScope.$on('refresh-business-data', () => {
    api.activate()
  })

  $scope.$on('$destroy', () => {
    deregisterRefreshBusinessData()
  })

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('units')
  })

  $scope.createContext = () => {
    ModalService.close()
    api.getBusinessDataCreateEditDialogController().then(({ BusinessDataCreateEditDialogController }) => {
      ModalService.showModal({
        templateId: 'businessDataCreateEditDialog.html',
        templateUrl: '/arts/dialogs/business-data/create-edit/business-data-create-edit-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: BusinessDataCreateEditDialogController,
        data: {
          newContext: true,
          page: 'profile'
        }
      })
    })
  }

  $scope.headerNavigation = {
    buttons: [{
      type: 'button',
      btnType: 'primary',
      label: $translate.instant('addBusinessData'),
      icon: 'plus',
      onClick: $scope.createContext
    }]
  }
}

export { ProfileBusinessDataController }
